import React, { FC } from 'react';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Radio from '@mui/material/Radio';

interface ModuleRowProps {
  module: any;
  tierOptions: any;
  formValues: any;
  setFormValues: any;
}

const ModuleRow: FC<ModuleRowProps> = (props) => {
  const { module, tierOptions, formValues, setFormValues } = props;

  const handlePermissionChange = (newTier: number) => {
    const updatedFormValues = formValues.map((elem: any) => {
      if (elem.id === module.id) {
        return { ...elem, permission_tier: newTier };
      }
      return elem;
    });

    setFormValues(updatedFormValues);
  };

  return (
    <TableRow key={module.name}>
      <TableCell>{module.name}</TableCell>
      {tierOptions.map((tierOption: any, index: number) => {
        const currentModule = formValues?.find((elem: any) => elem.id === module.id);
        const isChecked = index === currentModule?.permission_tier;

        return (
          <TableCell key={`${module.name}-${tierOption.value}`}>
            <Radio checked={isChecked} onChange={() => handlePermissionChange(index)} disabled={false} />
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default ModuleRow;
